<template>
  <div class="margin-70">
    <dv-border-box-12 class="operaBox flex flex-direction justify-center padding-sm margin-top-sm">
      <div
        class="operation flex align-center justify-center"
        v-for="(item,index) in overviewList"
        :key="index"
      >
        <div class="margin-right-sm">
          <img class="operateIcon" :src="item.img" />
          <img
            class="right-icon margin-left-sm"
            src="../../assets/images/site/tri.png"
          >
        </div>
        <div class="flex flex-direction text-box">
          <p class="text-xss">{{item.text}}</p>
          <p class="text-sm DS-font margin-top-sm">{{item.number}}</p>
        </div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
// 综合态势--动态渲染图片
import overview0 from "@/assets/images/site/station.png";
import overview1 from "@/assets/images/index/overview3.png";
import overview2 from "@/assets/images/site/statinTimepng.png";
import overview3 from "@/assets/images/site/station-day.png";
import overview4 from "@/assets/images/site/stationCar.png";
import { dataInterface } from '@/api/dataInterfaceApi';
import {formatTime} from '@/utils/index'

export default {
  data() {
    return {
      options: {},
      overviewList: [
        {
          text: "站点",
          number: "",
          img: overview0,
        },
        {
          text: "类型",
          number: "",
          img: overview1,
        },
        {
          text: "建站时间",
          number: "",
          img: overview2,
        },
        {
          text: "运营天数",
          number: "",
          img: overview3,
        },
        {
          text: "支持车型",
          number: "",
          img: overview4,
        },
      ],
    };
  },
  components: {},
  props: {
    // operList: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  watch: {},
  mounted() {
  },
  methods: {
    getData(data) {
      this.selectStationInfo(data);
    },
    //综合态势
    selectStationInfo(data = {}) {
      let _this = this;
      let params = {
					"enCode":"TiDB-zhandian-zhandianxinxi",//TiDB-站点-站点信息
          "@station_id":data.stationId
				}
        dataInterface
        .dataFaceApiXZ(params)
        .then((res) => {
          if (!res) return;
          res = res[0];
          _this.overviewList = [
            {
              text: "站点",
              number: res.stationName.toString(),
              img: overview0,
            },
            {
              text: "类型",
              number:  res.stationType,
              img: overview1,
            },
            {
              text: "建站时间",
              number: formatTime(res.constructionTime,'yyyy-MM-dd'),
              img: overview2,
            },
            {
              text: "运营天数",
              number: res.safeDays,
              img: overview3,
            },
            {
              text: "支持车型",
              number: res.vehicleBrand+res.vehicleName,
              img: overview4,
            },
          ];
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.margin-70 {
  margin: 70px;
  margin-bottom: 0;
}
.operaBox {
  width: 370px;
}
.operation {
  height: 144px;
}
.operateIcon{
  width:82px;
}
.operation-icon {
  width: 82px;
  height: 72px;
}
.right-icon {
  width: 14px;
  height: 16px;
}
.text-box {
  width: 140px;
}
.DS-font {
  line-height: 24px;
  font-family: "DS-Digital-Bold";
}
</style>